// extracted by mini-css-extract-plugin
export default {"container":"StripePaymentElement_container__sx5+T","paymentButton":"StripePaymentElement_paymentButton__Z-dtx"};